import { render } from "./WebsitePreviewItem.vue?vue&type=template&id=0c458035&scoped=true"
import script from "./WebsitePreviewItem.vue?vue&type=script&lang=js"
export * from "./WebsitePreviewItem.vue?vue&type=script&lang=js"

import "./WebsitePreviewItem.vue?vue&type=style&index=0&id=0c458035&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c458035"]])

export default __exports__